export const DECO_NAME = "blurSelection";
export const DECO_CLASS = "blur-selection";
export const RESTORE_SELECTION_META_KEY = "restoreSelection";
export const SAVE_SELECTION_META_KEY = "saveSelection";
